module.exports = __webpack_public_path__ + "static/media/3_bestellschein_frei.c0916ff8.png";